module.exports = require('./helpers/bundle-url').getBundleURL('gvXu3') + "logo.c51670a8.svg";